<template>
    <div id="rowSection">
       <div class="columns" :class="{ reverse: isReversed }">
           <div class="column is-8">
               <h5 v-if="challenge.title" class="challenge-title is-size-3 has-text-left">{{ $t(challenge.title) }}</h5>
               <p v-html="$t(challenge.content)"></p>   
            </div>
            <div class="column is-3">
                <figure class="image is-square">
                    <img :src="challenge.imagePath" alt="sdasd">
                </figure>            
           </div>
       </div>
    </div>
</template>

<script>

export default{
    props: [
        'isReversed',
        'challenge',
    ],
}
</script>

<style lang="scss" scoped>

#rowSection {
    border-bottom: 1px solid $secondary-color;
}

.columns {
    margin-bottom: 2rem;
    margin-top: 2rem;
    justify-content: space-between;
}

.reverse {
    flex-direction: row-reverse;
}

img {
    object-fit: cover;
}

.challenge-title {
    margin-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  .columns {
      display: flex;
      flex-direction: column-reverse;
  }
 
}

</style>